module.exports = __webpack_public_path__ + "media/images/linked-f64284fe.svg";